import { OperatorFindDto, type OperatorFindInterface } from '@zaoblako/shared/modules/finance/dtos/operator/operator-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import * as yup from 'yup';

/** Kkts response body */
export interface KktFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Creation date and time */
  created: Date;
  /** Serial number */
  serialNumber: string;
  /** Registration number */
  regNumber: string;
  /** Fiscal storage */
  fnNumber: string;
  /** Registration address */
  address?: string;
  /** Kkt model */
  model?: string;
  /** Operator OFD */
  operator?: OperatorFindInterface;
  /** Contragent */
  contragent: ContragentFindInterface;
  /** Deleted date */
  deleted?: Date;
}

/** Kkt response body - DTO schema */
export const KktFindDto = SerdeDtoClass.create<KktFindInterface>(FinanceDtoKeysEnum.KKT_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Дата создания',
    serializer: yup.date(),
  },
  serialNumber: {
    label: 'Серийный номер',
    serializer: yup.string(),
  },
  regNumber: {
    label: 'Регистрационный номер',
    serializer: yup.string(),
  },
  fnNumber: {
    label: 'Номер фискального накопителя',
    serializer: yup.string(),
  },
  address: {
    sortable: true,
    optional: true,
    label: 'Адрес',
    serializer: yup.string(),
  },
  model: {
    sortable: true,
    optional: true,
    label: 'Модель',
    serializer: yup.string(),
  },
  operator: {
    sortable: true,
    optional: true,
    label: 'Оператор ОФД',
    nested: OperatorFindDto,
    serializer: (_, nested) => nested,
  },
  contragent: {
    sortable: true,
    optional: true,
    label: 'Контрагент',
    nested: ClientDtoKeysEnum.CONTRAGENT_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  deleted: {
    optional: true,
    label: 'Удалено',
    serializer: yup.date(),
  },
});
